export const ports = {
  trigger: ['out'],
  send: ['out'],
  wait: ['reply', 'invalid', 'timeout'],
  branch: ['yes', 'no'],
  conditions: ['yes', 'no'],
  hours: ['yes', 'no'],
  http: ['success', 'failure'],
  ai: ['success', 'failure'],
  until: ['out'],
  call: ['out'],
  label: ['out'],
  assign: ['out'],
  attribute: ['out'],
  delay: ['out'],
  handoff: [],
  end: [],
};
export const settings = type =>
  ({
    trigger: { inbox_id: null, event: 'first_message' },
    send: { text: '' },
    wait: { variable: 'answer', seconds: 300, choices: [] },
    branch: { variable: 'answer', operator: 'equals', value: '1' },
    conditions: {
      mode: 'all',
      rules: [
        { source: 'variable', key: 'answer', operator: 'equals', value: '1' },
      ],
    },
    hours: {
      timezone: 'Asia/Bangkok',
      days: [1, 2, 3, 4, 5],
      start: '09:00',
      finish: '18:00',
    },
    http: {
      connection_id: null,
      query: {},
      body: {},
      mapping: {},
      status_variable: 'http_status',
    },
    ai: {
      mode: 'answer',
      prompt: '{{last_message}}',
      variable: 'ai_answer',
      choices: [],
    },
    until: { at: new Date(Date.now() + 3600000).toISOString() },
    call: { flow_id: null },
    label: { label: '' },
    assign: { team_id: null, agent_id: null },
    attribute: { key: '', value: '' },
    delay: { seconds: 60 },
    handoff: {},
    end: {},
  })[type];

export function template(meta, blank = false) {
  const inbox =
    meta.inboxes.find(i => i.channel === 'Channel::Line') || meta.inboxes[0];
  const firstTeam =
    meta.teams.find(item => /ขาย|sales/i.test(item.name)) || meta.teams[0];
  const secondTeam =
    meta.teams.find(
      item =>
        item.id !== firstTeam?.id && /บริการ|support|service/i.test(item.name)
    ) ||
    meta.teams.find(item => item.id !== firstTeam?.id) ||
    firstTeam;
  const team = firstTeam?.id || null;
  const team2 = secondTeam?.id || null;
  const node = (id, type, name, x, y, config, next) => ({
    id,
    type,
    name,
    x,
    y,
    config,
    next,
  });
  const root = node(
    'start',
    'trigger',
    'ลูกค้าทักครั้งแรก',
    50,
    70,
    { inbox_id: inbox?.id || null, event: 'first_message' },
    { out: blank ? 'finish' : 'menu' }
  );
  if (blank)
    return {
      schema: 1,
      nodes: [root, node('finish', 'end', 'จบ', 400, 70, {}, {})],
    };
  return {
    schema: 1,
    nodes: [
      root,
      node(
        'menu',
        'send',
        'ส่งเมนูต้อนรับ',
        50,
        250,
        {
          text: `สวัสดีค่ะ คุณ {{contact_name}} ต้องการติดต่อเรื่องใดคะ\nพิมพ์ 1 ติดต่อ${firstTeam?.name || 'ทีมที่ 1'}\nพิมพ์ 2 ติดต่อ${secondTeam?.name || 'ทีมที่ 2'}`,
        },
        { out: 'answer' }
      ),
      node(
        'answer',
        'wait',
        'รอคำตอบลูกค้า',
        50,
        450,
        { variable: 'answer', seconds: 300, choices: ['1', '2'] },
        { reply: 'route', invalid: 'invalid', timeout: 'timeout' }
      ),
      node(
        'route',
        'branch',
        'เลือกทีมตามคำตอบ',
        450,
        180,
        { variable: 'answer', operator: 'equals', value: '1' },
        { yes: 'sales', no: 'service' }
      ),
      node(
        'sales',
        'assign',
        'ส่งเข้าทีมที่ 1',
        830,
        60,
        { team_id: team, agent_id: null },
        { out: 'confirm' }
      ),
      node(
        'service',
        'assign',
        'ส่งเข้าทีมที่ 2',
        830,
        290,
        { team_id: team2, agent_id: null },
        { out: 'confirm' }
      ),
      node(
        'invalid',
        'send',
        'คำตอบไม่ตรงตัวเลือก',
        450,
        510,
        { text: 'ได้รับข้อความแล้วค่ะ จะส่งเรื่องให้เจ้าหน้าที่ช่วยดูแลต่อ' },
        { out: 'handoff' }
      ),
      node(
        'timeout',
        'send',
        'หมดเวลารอ',
        450,
        740,
        {
          text: 'หากต้องการความช่วยเหลือเพิ่มเติม ฝากข้อความไว้ได้เลยค่ะ เจ้าหน้าที่จะรับเรื่องต่อ',
        },
        { out: 'handoff' }
      ),
      node(
        'confirm',
        'send',
        'ยืนยันการส่งต่อ',
        1190,
        180,
        { text: 'รับเรื่องแล้วค่ะ กำลังส่งต่อให้เจ้าหน้าที่ดูแลต่อ' },
        { out: 'handoff' }
      ),
      node('handoff', 'handoff', 'เจ้าหน้าที่รับช่วง', 1190, 550, {}, {}),
    ],
  };
}

const th = {
  hookUrl: 'ที่อยู่รับเหตุการณ์',
  conditions: 'เงื่อนไขหลายข้อ',
  hours: 'ช่วงเวลาทำการ',
  http: 'เรียกระบบภายนอก',
  ai: 'เอไอ ตอบหรือจัดหมวด',
  until: 'รอถึงวันเวลา',
  success: 'สำเร็จ',
  failure: 'ไม่สำเร็จ / ให้คนรับช่วง',
  external: 'รอ API / เอไอ',
  schedule: 'เริ่มตามตารางเวลา',
  fixtures: 'ผลจำลอง API / เอไอ และข้อมูลลูกค้า (JSON)',
  fixturesHelp:
    'ใส่รหัสบล็อกและผล success/variables; ไม่มีผลจำลองจะเข้าทางไม่สำเร็จ การทดลองไม่เรียก API หรือ เอไอ จริง',
  title: 'เวิร์กโฟลว์',
  subtitle: 'ออกแบบกระบวนการตอบแชทและส่งต่อเจ้าหน้าที่',
  new: 'สร้าง เวิร์กโฟลว์',
  blank: 'เริ่มจากว่าง',
  example: 'ใช้ตัวอย่างเมนูและส่งต่อ',
  all: 'รายการ เวิร์กโฟลว์',
  edit: 'แก้ไข',
  back: 'กลับรายการ',
  name: 'ชื่อ เวิร์กโฟลว์',
  blockName: 'ชื่อบล็อก',
  draft: 'ฉบับร่าง',
  published: 'เปิดใช้อยู่',
  stopped: 'หยุดแล้ว',
  archived: 'เก็บเข้าคลัง',
  save: 'บันทึกฉบับร่าง',
  saved: 'บันทึกแล้ว',
  publish: 'เปิดใช้งาน',
  stop: 'หยุด เวิร์กโฟลว์',
  clone: 'ทำสำเนา',
  archive: 'เก็บเข้าคลัง',
  archiveConfirm: 'เก็บ เวิร์กโฟลว์ นี้เข้าคลังใช่ไหม?',
  canvas: 'ผังการทำงาน',
  test: 'ทดลอง',
  runs: 'ประวัติการทำงาน',
  refresh: 'โหลดใหม่',
  palette: 'เพิ่มบล็อก',
  inspector: 'ตั้งค่าบล็อก',
  chooseNode: 'คลิกบล็อกเพื่อตั้งค่า',
  connectHelp: 'ลากบล็อกเพื่อจัดตำแหน่ง · คลิกจุดทางออก แล้วคลิกบล็อกปลายทาง',
  connecting: 'เลือกบล็อกปลายทาง หรือกดยกเลิก',
  cancel: 'ยกเลิก',
  delete: 'ลบบล็อก',
  output: 'ทางออก',
  target: 'บล็อกปลายทาง',
  disconnected: 'ยังไม่เชื่อม',
  undo: 'ย้อนกลับ',
  redo: 'ทำซ้ำ',
  trigger: 'เริ่มต้น',
  call: 'เรียกผังย่อย',
  subflow: 'ผังย่อย — เรียกจากผังอื่น',
  webhook: 'เหตุการณ์จากระบบอื่น',
  routingHelp:
    'เลขความสำคัญสูงเริ่มก่อน หากเท่ากันใช้ผังที่สร้างก่อน แต่ละแชททำงานทีละผัง เหตุการณ์ระหว่างรอจะส่งให้ผังปัจจุบัน',
  routingPriority: 'ลำดับความสำคัญ (0–100)',
  reentry: 'เมื่อผังจบแล้ว',
  once: 'เริ่มได้ครั้งเดียวต่อแชท',
  perMessage: 'เริ่มใหม่ได้เมื่อมีข้อความหรือเหตุการณ์ใหม่',
  entryFilter: 'เริ่มเฉพาะเมื่อผ่านเงื่อนไข',
  subflowHelp:
    'เลือกผังย่อยในกล่องเดียวกันที่เปิดใช้แล้ว ตัวแปรใช้ร่วมกัน บล็อกจบจะกลับมาขั้นถัดไป รวมทั้งหมดไม่เกิน 50 บล็อก การเปิดใช้ผังหลักจะตรึงรุ่นผังย่อยไว้ การหยุดผังย่อยจะหยุดผังหลักที่อ้างอิงด้วย',
  hookHelp:
    'บันทึกก่อนสร้างกุญแจ ระบบต้นทางต้องส่งลายเซ็น HMAC-SHA256 พร้อมเวลาและรหัสเหตุการณ์ไม่ซ้ำ URL ในเครื่องนี้ยังรับจากภายนอกไม่ได้',
  hookConfirm: 'เปลี่ยนการรับเหตุการณ์และยกเลิกกุญแจเดิมทันทีใช่ไหม?',
  hookRotate: 'เปิดรับและสร้างกุญแจใหม่',
  hookDisable: 'ปิดรับเหตุการณ์',
  hookSecret: 'กุญแจลับ — แสดงครั้งนี้เท่านั้น',
  copySecret: 'คัดลอกกุญแจ',
  copyFailed: 'เบราว์เซอร์ไม่อนุญาตให้คัดลอก กรุณาอนุญาตคลิปบอร์ดแล้วลองใหม่',
  hookSaved: 'บันทึกแล้ว ต้องเปิดใช้ผังก่อนรับเหตุการณ์ กุญแจเดิมใช้ต่อไม่ได้',
  teamOwnership: 'รับและส่งต่องาน',
  currentOwner: 'ผู้รับงานปัจจุบัน',
  unassigned: 'ยังไม่มีผู้รับงาน',
  claim: 'รับงานนี้',
  noTeam: 'ไม่ระบุทีม',
  selectAgent: 'เลือกเจ้าหน้าที่',
  transfer: 'ส่งต่อให้เจ้าหน้าที่',
  resumeNext: 'อนุญาต เวิร์กโฟลว์ ครั้งถัดไป',
  resumeConfirm:
    'อนุญาตให้ เวิร์กโฟลว์ ที่ตรงเงื่อนไขเริ่มเมื่อมีเหตุการณ์ใหม่หรือถึงรอบตั้งเวลาใช่ไหม? ระบบจะไม่ส่งข้อความทันที',
  claimHelp:
    'การรับงานจะหยุดบอตในแชทนี้ หากมีคนรับงานไปแล้ว ระบบจะให้โหลดข้อมูลใหม่',
  send: 'ส่งข้อความ',
  wait: 'รอคำตอบ',
  branch: 'เงื่อนไข',
  label: 'ติดป้าย',
  assign: 'มอบหมายทีม',
  attribute: 'บันทึกข้อมูลแชท',
  delay: 'รอเวลา',
  handoff: 'ส่งต่อเจ้าหน้าที่',
  end: 'จบ เวิร์กโฟลว์',
  out: 'ถัดไป',
  reply: 'ได้รับคำตอบ',
  invalid: 'คำตอบไม่ตรง',
  timeout: 'หมดเวลา',
  yes: 'ใช่',
  no: 'ไม่ใช่',
  inbox: 'กล่องข้อความ',
  event: 'เริ่มเมื่อ',
  first_message: 'ข้อความแรกของแชทใหม่',
  incoming_message: 'ได้รับข้อความในแชทที่ยังไม่มีเจ้าหน้าที่ตอบ',
  text: 'ข้อความ',
  variable: 'ตัวแปร',
  variablesHelp:
    'ใช้ตัวแปร contact_name, last_message หรือชื่อคำตอบ เช่น answer โดยครอบชื่อด้วยปีกกาคู่',
  seconds: 'เวลารอ (วินาที)',
  choices: 'คำตอบที่ยอมรับ คั่นด้วยจุลภาค (เว้นว่างเพื่อรับข้อความทั่วไป)',
  operator: 'การเปรียบเทียบ',
  equals: 'เท่ากับ',
  contains: 'มีข้อความ',
  value: 'ค่า',
  team: 'ทีม',
  agent: 'เจ้าหน้าที่',
  teamOnly: 'ส่งเข้าทีม / ให้ระบบมอบหมายตามการตั้งค่า',
  field: 'ฟิลด์ข้อมูลแชท',
  select: 'เลือก',
  running: 'กำลังทำงาน',
  waiting: 'กำลังรอ',
  completed: 'เสร็จแล้ว',
  handed_off: 'เจ้าหน้าที่รับช่วงแล้ว',
  error: 'พบข้อผิดพลาด',
  empty: 'ยังไม่มี เวิร์กโฟลว์',
  emptyRuns: 'ยังไม่มีการทำงานจริงของ เวิร์กโฟลว์ นี้',
  previewInfo: 'ทดลองกับข้อมูลจำลองเท่านั้น ไม่ส่งข้อความหาลูกค้า',
  initial: 'ข้อความแรกของลูกค้า',
  replies: 'คำตอบลูกค้า (หนึ่งบรรทัดต่อข้อความ)',
  scenario: 'เหตุการณ์ทดลอง',
  normal: 'ตอบตามข้อความ',
  expire: 'ทดสอบหมดเวลา',
  human: 'เจ้าหน้าที่รับช่วง',
  runTest: 'เริ่มทดลอง',
  result: 'ผลการทดลอง',
  trace: 'ลำดับการทำงาน',
  effects: 'การกระทำจำลอง',
  noSend: 'ข้อความที่ส่งให้ลูกค้าจริง: 0',
  publishInfo:
    'เมื่อเปิดใช้ เวิร์กโฟลว์ จะส่งข้อความและทำงานกับลูกค้าในกล่องที่เลือกจริง',
  publishCheck: 'ตรวจกล่อง ทีม ข้อความ และผลทดลองแล้ว ยืนยันเปิดใช้งาน',
  publishWarning:
    'เปิดหลายผังต่อกล่องได้ เลือกตามเงื่อนไขและลำดับความสำคัญ · แต่ละแชททำงานทีละผัง · เจ้าหน้าที่รับช่วงแล้วบอตจะหยุดจนกว่าจะอนุญาตใหม่ · หยุดผังย่อยจะหยุดผังหลักที่อ้างอิงด้วย',
  rulesWarning:
    'มีกฎอัตโนมัติเดิมในบัญชีนี้ ตรวจว่ากฎเหล่านั้นไม่ตอบหรือมอบหมายขัดกับ เวิร์กโฟลว์',
  publishedLocked:
    'เวิร์กโฟลว์ เปิดใช้อยู่ กรุณาหยุดก่อนแก้ไข รุ่นที่รันจะไม่เปลี่ยนกลางแชท',
  stopConfirm:
    'หยุด เวิร์กโฟลว์ และยกเลิกการรอของแชทที่อยู่ใน เวิร์กโฟลว์ นี้ใช่ไหม?',
  activeVersion: 'รุ่นที่เปิดใช้',
  chat: 'แชท',
  detail: 'รายละเอียด',
  stopRun: 'หยุดสำหรับแชทนี้',
  unsaved: 'มีการแก้ไขที่ยังไม่บันทึก ต้องการออกจากหน้านี้หรือไม่?',
  saveFirst: 'บันทึกการแก้ไขก่อนเปิดใช้งาน',
  choose: 'เลือก เวิร์กโฟลว์',
  export: 'ส่งออก JSON',
  import: 'นำเข้า JSON',
  imported: 'นำเข้าเป็นฉบับร่างแล้ว กรุณาตรวจกล่องและทีม',
  added: 'เพิ่มบล็อกแล้ว',
  deleted: 'ลบบล็อกแล้ว กรุณาเชื่อมเส้นทางใหม่',
  zoomIn: 'ขยาย',
  zoomOut: 'ย่อ',
  validation: 'ตรวจเส้นทางและการตั้งค่า',
  noRuns: 'บันทึก เวิร์กโฟลว์ ก่อนดูประวัติ',
  messages: 'ข้อความใน Chatwoot',
  acceptedNote: 'สถานะข้อความมาจาก Chatwoot ไม่ใช่การรับรองว่าลูกค้าอ่านแล้ว',
  timeoutNote: 'เวลาหมดอายุอาจคลาดเคลื่อนได้ประมาณหนึ่งนาทีตามรอบตรวจคิว',
  readonly: 'ดูรุ่นที่บันทึก',
  stoppedNotice: 'หยุด เวิร์กโฟลว์ แล้ว',
  working: 'กำลังดำเนินการ',
};
const en = {
  ...th,
  title: 'Workflow',
  subtitle: 'Design chat journeys and hand off to your team',
  all: 'Workflows',
  new: 'Create workflow',
  blank: 'Start blank',
  example: 'Menu and handoff template',
  edit: 'Edit',
  back: 'Back',
  name: 'Workflow name',
  draft: 'Draft',
  published: 'Published',
  stopped: 'Stopped',
  save: 'Save draft',
  saved: 'Saved',
  publish: 'Publish',
  stop: 'Stop workflow',
  clone: 'Clone',
  canvas: 'Builder',
  test: 'Test',
  runs: 'Run history',
  refresh: 'Refresh',
  palette: 'Add step',
  trigger: 'Trigger',
  send: 'Send message',
  wait: 'Wait for reply',
  branch: 'Branch',
  label: 'Add label',
  assign: 'Assign team',
  attribute: 'Set conversation field',
  delay: 'Wait',
  handoff: 'Human handoff',
  end: 'End',
  out: 'Next',
  reply: 'Reply',
  invalid: 'Invalid',
  timeout: 'Timeout',
  yes: 'Yes',
  no: 'No',
};
export const messages = { th: { WF: th }, en: { WF: en } };
